<div class="create-order-container">
	<div class="create-order-form-container">
		<cv-create-order-form></cv-create-order-form>
	</div>
	<div class="create-order-progress-tracker-table-container">
		<cv-create-order-progress-tracker-table></cv-create-order-progress-tracker-table>
	</div>
</div>